import { IconType } from "@common/declarations";
import { sort } from "@common/lib/array";
import { isNull, last } from "lodash";
import { type SlidersValue } from "../Content";
import { type PackagePricing } from "../types";

type ListItem = {
  caption: string;
  icon: IconType;
};
export const getListItems = (
  tiers: PackagePricing.Api.Tiers,
  frequency: PackagePricing.BillingFrequencyKey
): ListItem[] => [
  { caption: "FULL access to all features", icon: IconType.ArrowRight },
  { caption: "FULL access to support", icon: IconType.ArrowRight },
  { caption: "Unlimited domains", icon: IconType.ArrowRight },
  { caption: "Unlimited funnels", icon: IconType.ArrowRight },
  { caption: "Unlimited pages", icon: IconType.ArrowRight },
  { caption: "Unlimited products", icon: IconType.ArrowRight },
  { caption: "Unlimited courses", icon: IconType.ArrowRight },
  { caption: "Unlimited membership areas", icon: IconType.ArrowRight },
  { caption: "Unlimited websites", icon: IconType.ArrowRight }
];

export const getMonthPrice = (price: number, frequency: PackagePricing.BillingFrequencyKey): number => {
  switch (frequency) {
    case "Month":
      return price;
    case "Quarter":
      return price / 3;
    case "Year":
      return price / 12;
  }
};

const getTierCountPricesProp = (
  frequency: PackagePricing.BillingFrequencyKey
): keyof PackagePricing.Api.TierCountPrices => {
  switch (frequency) {
    case "Month":
      return "usdMonthPrice";
    case "Quarter":
      return "usdQuarterPrice";
    case "Year":
      return "usdYearPrice";
  }
};

// type TierValue = {
//   start: number;
//   end: number | null;
//   amount: number;
// };
// export const getTierValues = (
//   tiers: PackagePricing.Api.TierCount[],
//   frequency: PackagePricing.BillingFrequencyKey
// ): TierValue[] =>
//   tiers.map((x) => ({
//     amount: x[getTierCountPricesProp(frequency)],
//     end: x.endValue,
//     start: x.startValue
//   }));

export const getTierFees = (
  tiers: PackagePricing.Api.TierCount[],
  frequency: PackagePricing.BillingFrequencyKey,
  isChargePerEntity: boolean,
  value: number
): number => {
  if (!tiers.length) return 0;

  const values = tiers.map((x) => ({
    amount: x[getTierCountPricesProp(frequency)],
    end: x.endValue,
    start: x.startValue
  }));
  const sorted = sort(values, { key: "start" });

  if ((last(sorted)!.end ?? value) < value)
    throw new Error("BUG. Max value cannot greater than the last tier end value");

  return sorted.reduce((res, x) => {
    if (x.start > value) return res;
    if (!isChargePerEntity) return res + x.amount;

    const to = isNull(x.end) ? value : Math.min(x.end, value);
    return res + (to - (x.start - 1)) * x.amount;
  }, 0);
};

export const getFees = (
  pckg: PackagePricing.Api.Package,
  tiers: PackagePricing.Api.Tiers,
  frequency: PackagePricing.BillingFrequencyKey,
  sliders: SlidersValue
): number =>
  getTierFees(tiers.contacts, frequency, pckg.chargePerContact, sliders.contacts) +
  getTierFees(tiers.staff, frequency, pckg.chargePerStaff, sliders.staff);
